// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unauthorized-block[data-v-25bfcc07]{background-color:var(--bg-primary-block);margin-left:auto;margin-right:auto;-webkit-box-shadow:var(--shadow-primary-block);box-shadow:var(--shadow-primary-block);border-radius:4px;margin-top:.75rem;width:40rem;padding:5.3rem 5rem 3.9rem}@media(max-width:767.98px){.unauthorized-block[data-v-25bfcc07]{width:calc(100% - 15px);padding:2rem 1.5rem 2rem}}", ""]);
// Exports
module.exports = exports;
